import { FieldProps } from 'formik';
import { CollectionAutocomplete } from '../collection-autocomplete';
import { FilterItem } from '@sr/dto';

export const SimplePicker = <ItemIdType extends string | number = number>({ form, field, meta, label, items }: FieldProps<number, any> & { items: FilterItem<ItemIdType>[]; label: string }) => {
  return <CollectionAutocomplete<ItemIdType> field={field} form={form} isLoading={false} items={items} clearable={true} label={label} meta={meta} />;
};
